<script setup lang="ts">
import type { Subject } from "~/types/subject"

const props = defineProps<{ chapter: Subject }>()

const { imageType, calculateCardImageStyle } = useChapterCard(props)

const classes = useThemedClasses(() => props.chapter.colorTag)

const cardGradientClass = computed(
  () => imageType.value === "backgroundImage"
    ? [classes.value.gradientImage()]
    : [classes.value.gradient(), classes.value.background()],
)

const mediaCounts = useMediaCounts(() => props.chapter)

const subjectHasContent = useHasContent(
  mediaCounts.data,
  () => props.chapter.introPages.length > 0,
)
</script>

<template>
  <div class="relative aspect-[1/1] w-full lg:h-[511px]">
    <div
      class="absolute inset-0 z-10 -translate-x-2 translate-y-2 rounded-2xl bg-[--theme-lightest]"
    />
    <div
      class="absolute inset-0 z-20 rounded-xl shadow-md"
      :class="{
        'duration-200 hover:-translate-y-1 hover:translate-x-1':
          subjectHasContent,
      }"
      :style="
        imageType === 'backgroundImage' ? calculateCardImageStyle : {}
      "
    >
      <NuxtLink
        v-if="chapter.frontendHref"
        :id="`chapter-card-${chapter.id}`"
        data-pendo="chapter-card"
        class="item-start z-30 flex size-full flex-col justify-between rounded-xl px-4 py-6 lg:flex-row lg:items-end lg:px-11 lg:py-20"
        :class="[
          ...cardGradientClass,
          !subjectHasContent
            ? 'pointer-events-none cursor-default'
            : 'cursor-pointer',
        ]"
        :to="chapter.frontendHref"
      >
        <div
          class="flex h-3/5 items-center justify-center lg:h-full lg:w-1/2"
        >
          <img
            v-if="imageType === 'illustration' && chapter.img"
            :src="chapter.img.src"
            :alt="chapter.img.alt"
            class="size-full object-contain"
          />
        </div>

        <UChapterCardContent :chapter="chapter" />
      </NuxtLink>
    </div>
  </div>
</template>
